import {Map} from 'immutable';
import {combineReducers} from 'redux-immutable';
import authenticationReducer, {
  AuthenticationState,
} from './reducers/authentication';
import compositionsReducer, {CompositionsState} from './reducers/compositions';
import globalConfigurationReducer, {
  LetrusGlobalConfigurationState,
} from './reducers/globalConfiguration';
import learningPathReducer, {LearningPathState} from './reducers/learningPath';
import pedagogicalContentReducer, {
  PedagogicalContentsState,
} from './reducers/pedagogicalContents';
import profileReducer, {ProfileState} from './reducers/profile';
import questionnairesReducer, {
  QuestionnairesState,
} from './reducers/questionnaires';
import termsReducer, {TermsState} from './reducers/terms';
import toggleCompletedTestReportReducer, {
  ToggleCompletedTestReportState,
} from './reducers/toggle';
import userFeelingsReducer, {UserFeelingsState} from './reducers/userFeelings';

export interface ApplicationState extends Map<any, any> {
  readonly authentication: AuthenticationState;
  readonly compositions: CompositionsState;
  readonly globalConfiguration: LetrusGlobalConfigurationState;
  readonly learningPath: LearningPathState;
  readonly questionnaires: QuestionnairesState;
  readonly pedagogicalContents: PedagogicalContentsState;
  readonly toggleCompletedTestReport: ToggleCompletedTestReportState;
  readonly userFeelings: UserFeelingsState;
  readonly profile: ProfileState;
  readonly terms: TermsState;
}

const appReducer = combineReducers({
  authentication: authenticationReducer,
  compositions: compositionsReducer,
  globalConfiguration: globalConfigurationReducer,
  learningPath: learningPathReducer,
  questionnaires: questionnairesReducer,
  pedagogicalContents: pedagogicalContentReducer,
  toggleCompletedTestReport: toggleCompletedTestReportReducer,
  userFeelings: userFeelingsReducer,
  profile: profileReducer,
  terms: termsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_STORE') {
    // Resetting the state to undefined will reinitialize all reducers
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
